<template>
  <router-link :to="goList ? { name: 'ReadingDayAudio' } : item.path"
               class="list-item-component"
               v-ym-report:[reportKey]="goList ? '' : { id: item.id }"
  >
    <ym-img class="list-item-component-left"
            :src="item.cover"
    />
    <div class="list-item-component-right">
      <div class="header">
        <div class="title">{{ item.title }}</div>
        <div class="desc">{{ item.desc }}</div>
      </div>
      <div class="footer">
        <div class="price">
          价格：<span>￥{{ item.price }}</span>
        </div>
        <div class="btn">立即收听</div>
      </div>
    </div>
  </router-link>
</template>

<script>
  export default {
    name: 'AudioItem',
    props: {
      item: {
        type: Object,
        required: true,
      },
      goList: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      reportKey() {
        return this.goList ? 'MARKETING_2021READINGDAY_RADIO_LISTEN_CLICK' : 'MARKETING_2021READINGDAY_RADIO_MORE_LISTEN_CLICK';
      },
    },
    data() {
      return {};
    },
    methods: {},
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .list-item-component {
    display: flex;
    margin-bottom: 55px;
    &:last-child {
      margin-bottom: 0;
    }
    &-left {
      width: 220px;
      height: 220px;
      margin-left: 16px;
    }
    &-right {
      flex: 1;
      padding: 20px 35px 10px 30px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .header {
        display: flex;
        flex-direction: column;
        .title {
          color: #e74933;
          font-size: @font-size-base;
          font-weight: @font-weight-bold;
          line-height: 40px;
          margin-bottom: 12px;
        }
        .desc {
          color: @color-text-light;
          font-size: @font-size-small;
        }
      }
      .footer {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .price {
          color: #e74933;
          font-size: @font-size-small;
          font-weight: @font-weight-bold;
          span {
            font-size: @font-size-large;
          }
        }
        .btn {
          width: 188px;
          height: 50px;
          border-radius: 25px;
          display: flex;
          justify-content: center;
          align-items: center;
          color: @color-white;
          font-size: @font-size-base;
          font-weight: @font-weight-bold;
          background: linear-gradient(0deg, #e84734 0%, #ea6b3d 100%);;
        }
      }
    }
  }
</style>
